{
  "id": "campaign-093",
  "name": "Ivy Walk",
  "seed": "campaign:93",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L..,.",
    ".....__....,",
    ".....__x..,.",
    ".i.i.__.i.i.",
    "...*L__.*...",
    ".....__x...~",
    ".i.i.__.i.i~",
    "....T__....~",
    ".....__x....",
    ".i.i.__.i.i.",
    "...*,__.*...",
    "....,__.....",
    ".i.i,__.i.i.",
    "....h__.....",
    ".x...__.%...",
    "..%%,__,%%..",
    "..%..,,.%...",
    "S..........X"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 10,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 3
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 15
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 93,
  "biome": "cemetery",
  "par": {
    "reel": 7690,
    "push": 6362,
    "selfPropelled": 5844,
    "tractor": 5080,
    "zeroTurn": 3807,
    "fairway": 3018
  },
  "routeTries": {
    "par": {
      "reel": 1,
      "push": 18,
      "selfPropelled": 17,
      "tractor": 9,
      "zeroTurn": 17,
      "fairway": 15
    }
  }
}
